import { useKeyboardShortcuts } from "../market-grid/keyboard";
import { CaretUpIcon, CaretDownIcon } from "../icons";

export const KeyboardShortcuts = ({ showMacKeys }: { showMacKeys: boolean }) => {
  const gridKeyboardShortcuts = useKeyboardShortcuts();

  const formatKey = (key: string, isMac: boolean) => {
    if (key === "ArrowUp") {
      return isMac ? <CaretUpIcon /> : "↑";
    }
    if (key === "ArrowDown") {
      return isMac ? <CaretDownIcon /> : "↓";
    }
    if (key === "ctrl" && isMac) return "⌃";
    if (key === "cmd" && isMac) return "⌘";
    if (key === "alt" && isMac) return "⌥";
    if (key === "shift" && isMac) return "⇧";
    return key;
  };

  return (
    <div className="grid [grid-template-columns:1fr_max-content] w-full gap-x-12 gap-y-4">
      {gridKeyboardShortcuts.map((shortcut) => {
        const filteredShortcuts = shortcut.shortcuts.filter((keyCombo) =>
          showMacKeys ? keyCombo.includes("cmd") : !keyCombo.includes("cmd"),
        );
        const keyCombo = filteredShortcuts[0];

        if (!keyCombo) return null;

        return (
          <div key={shortcut.name} className="grid col-span-full grid-cols-subgrid">
            <p className="">{shortcut.name}</p>
            <div className="flex gap-1 items-center justify-end">
              {keyCombo
                .split("+")
                .map((key) => formatKey(key, showMacKeys))
                .map((key, index) => (
                  <span
                    key={typeof key === "string" ? key : `arrow-${index}`}
                    className="inline-flex items-center justify-center h-[30px] min-w-[30px] px-2 text-foreground text-[14px] rounded-md border border-[var(--outline-default)] bg-[var(--surface-2)]"
                  >
                    {key}
                  </span>
                ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};
